import { SpriteView } from './SpriteView.ts';
import { ACTIVE_OPACITY, INACTIVE_OPACITY } from '../ui_utils/Utils.ts';
import { GeneralButtonView } from './GeneralButtonView.ts';
export class SpriteButtonView extends GeneralButtonView {
    addCenteredIcon(icon, overrideSize) {
        const sizeRatio = overrideSize == undefined ? this.iconDefaultSizeRatio : overrideSize;
        const newSizeY = this.viewContainer.initialPosition.h * sizeRatio;
        const newSizeX = icon.width / icon.height * newSizeY;
        const xMargin = (this.viewContainer.initialPosition.w - newSizeX) / 2;
        const yMargin = (this.viewContainer.initialPosition.h - newSizeY) / 2;
        const newIcon = new SpriteView(xMargin, yMargin, newSizeX, newSizeY, this.viewContainer, icon);
        this.assets.push(newIcon);
        this.centerIconInX(newIcon);
        this.centerIconInY(newIcon);
    }
    centerIconInX(asset) {
        const buttonBackgroundRightMargin = this.viewContainer.initialPosition.w * 0.02;
        const xMargin = (this.viewContainer.initialPosition.w - buttonBackgroundRightMargin - asset.width) / 2;
        asset.x = xMargin;
    }
    centerIconInY(asset) {
        const buttonBackgroundRightMargin = this.viewContainer.initialPosition.h * 0.02;
        const yMargin = (this.viewContainer.initialPosition.h - buttonBackgroundRightMargin - asset.height) / 2;
        asset.y = yMargin;
    }
    addAsset(asset) {
        this.assets.push(asset);
        if (asset.parent != undefined) asset.parent.removeChild(asset);
        this.viewContainer.addChild(asset);
    }
    isSameTexture(texture) {
        for (const asset of this.assets){
            const isContainer = asset.texture === undefined;
            if (isContainer) continue;
            if (asset.texture == texture) return true;
        }
        return false;
    }
    updateTexture(texture) {
        this.removeAllAssets();
        this.addCenteredIcon(texture);
    }
    activateOpacity() {
        this.updateOpacity(ACTIVE_OPACITY);
    }
    inactivateOpacity() {
        this.updateOpacity(INACTIVE_OPACITY);
    }
    isButtonOpactityActive() {
        for (const asset of this.assets){
            if (asset.alpha == ACTIVE_OPACITY) return true;
        }
        return false;
    }
    updateOpacity(opacity) {
        for (const asset of this.assets){
            if (asset.alpha == opacity) continue;
            asset.alpha = opacity;
        }
    }
    removeAllAssets() {
        for (const asset of this.assets){
            if (asset.parent == undefined) continue;
            asset.parent.removeChild(asset);
        }
    }
    constructor(x, y, w, h, container, removePadding, iconDefaultSizeRatio = 0.6){
        super(x, y, w, h, container, removePadding);
        this.iconDefaultSizeRatio = iconDefaultSizeRatio;
        this.assets = [];
    }
}
